import { render } from "./reporterApplyCityQuery.vue?vue&type=template&id=10719662&scoped=true"
import script from "./reporterApplyCityQuery.vue?vue&type=script&lang=js"
export * from "./reporterApplyCityQuery.vue?vue&type=script&lang=js"

import "./reporterApplyCityQuery.vue?vue&type=style&index=0&id=10719662&lang=less&scoped=true"
import "./reporterApplyCityQuery.vue?vue&type=style&index=1&id=10719662&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10719662"]])

export default __exports__